import { ErrorMessages } from '@/constants/errorMessages';
import { ServiceOptions } from '@/constants/services';
import { getEmailError, getOptionalPhoneError, getOptionalWebsiteError, getRequiredError } from '@/lib/validators';

export const ServicesIdPrefix = 'request-services';

export const ProjectRequestFieldIds = {
  name: 'request-name',
  company: 'request-company',
  email: 'request-email',
  phone: 'request-phone',
  companyType: 'request-company-type',
  serviceArea: 'request-service-area',
  website: 'request-website',
  engagement: 'request-engagement',
  budget: 'request-budget',
  services: `${ServicesIdPrefix}-${ServiceOptions[0].id}`,
  deadline: 'request-deadline',
  goals: 'request-goals',
  referral: 'request-referral',
};

export const ProjectRequestFieldOrder = Object.keys(ProjectRequestFieldIds);

export const EmptyProjectRequest = {
  name: '',
  company: '',
  email: '',
  phone: '',
  companyType: '',
  serviceArea: '',
  website: '',
  engagement: '',
  budget: '',
  services: [],
  deadline: '',
  goals: '',
  referral: '',
};

export function validateProjectRequest(values) {
  return {
    name: getRequiredError(values.name, ErrorMessages.name.required),
    company: getRequiredError(values.company, ErrorMessages.company.required),
    email: getEmailError(values.email),
    phone: getOptionalPhoneError(values.phone),
    companyType: getRequiredError(values.companyType, ErrorMessages.companyType.required),
    serviceArea: getRequiredError(values.serviceArea, ErrorMessages.serviceArea.required),
    website: getOptionalWebsiteError(values.website),
    engagement: getRequiredError(values.engagement, ErrorMessages.engagement.required),
    budget: null,
    services: values.services.length > 0 ? null : ErrorMessages.services.required,
    deadline: null,
    goals: getRequiredError(values.goals, ErrorMessages.goals.required),
    referral: null,
  };
}